import { ITableColumn } from '@components/common/UTable/UTable';

import {
  amountCols,
  indexCol,
  onNullableCell,
  rateCol,
  reasonsCol,
} from '@/pages/Report/columns/commonColumns';

export const taskColumns = [
  indexCol,
  {
    title: 'Объект',
    dataIndex: 'structuralDivisionName',
    sorter: true,
    width: 150,
  },
  {
    title: 'Дата формирования наряда',
    dataIndex: 'dateAt',
    type: 'date',
    sorter: true,
    width: 110,
  },
  ...amountCols(),
  rateCol(),
  reasonsCol,
  {
    title: 'Контроллер',
    dataIndex: 'executorFullName',
    sorter: true,
    width: 110,
    payload: { defaultValue: '-' },
    onCell: onNullableCell,
  },
  {
    title: 'Время выполнения наряда',
    dataIndex: 'executedAt',
    type: 'datetime',
    sorter: true,
    width: 110,
    payload: { defaultValue: '-' },
    onCell: onNullableCell,
  },
  {
    title: 'Геолокация контроллера',
    dataIndex: 'isNearDivision',
    sorter: true,
    width: 110,
    payload: { defaultValue: '-' },
    onCell: onNullableCell,
  },
] as ITableColumn[];
